import config from './config.yml';

export default (env = 'development') => config[env];
